import { Controller } from "@hotwired/stimulus"
import { getItem } from "../utils/local_storage"

export default class extends Controller {
  static targets = ["item", "all", "saved", "empty"]
  static values = { site: String }
  connect() { this.filter(false) }
  showAll() { this.filter(false) }
  showSaved() { this.filter(true) }

  filter(savedOnly) {
    this.itemTargets.forEach(item => {
      item.hidden = savedOnly && getItem(`devgab:signal:${this.siteValue}:article:${item.dataset.recordId}`, false) !== true
    })
    if (this.hasEmptyTarget) this.emptyTarget.hidden = this.itemTargets.some(item => !item.hidden)
    for (const [button, active] of [[this.allTarget, !savedOnly], [this.savedTarget, savedOnly]]) {
      button.classList.toggle("active", active)
      button.setAttribute("aria-pressed", String(active))
    }
  }
}
